<template>
  <div :id="errorField" class="input-container">
    <div v-if="fieldIcon" class="field-icon-container">
      <font-awesome-icon :icon="fieldIcon" />
    </div>
    <input
      :id="id"
      :placeholder="menuLabel"
      :value="value"
      v-bind="attrs"
      class="input-field"
      :type="inputType"
      @input="$emit('input', $event.target.value)"
      v-on="listeners"
    />
    <div v-if="picker" class="icon-wrapper" @click="$emit('picker-click')">
      <font-awesome-icon v-if="picker" :icon="picker" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'InputField',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Boolean, Number],
      default: ''
    },
    fieldIcon: {
      type: String,
      default: null
    },
    picker: {
      type: String,
      default: null
    },
    errorField: {
      type: String,
      default: null
    },
    menuLabel: {
      type: String,
      default: ''
    },
    id: {
      type: [String, Number],
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    }
  },
  computed: {
    attrs() {
      return this.$attrs;
    },
    listeners() {
      // eslint-disable-next-line no-unused-vars
      const { input, ...listeners } = this.$listeners;
      return listeners;
    }
  }
};
</script>

<style scoped lang="scss">
@import '../styles/colors.scss';

.input-container {
  display: flex;
  align-items: center;
  &.bordered {
    background-color: $white;
    border: 1px solid $blue;
  }
  &.bordered {
    height: 40px;
    background-color: $white;

    .field-icon-container,
    .icon-wrapper {
      display: flex;
      width: 40px;
      justify-content: center;
      height: 100%;
      align-items: center;
      border-right: 1px solid $blue;
      background-color: $blue;
      color: $white;
    }
    .icon-wrapper {
      border-right: 0;
      border-left: 1px solid $blue;
    }
  }
  input[readonly='readonly'] {
    border: 0;
  }
  .input-field {
    width: 100%;
    height: 100%;
    font-size: 0.9em;
    border: none;
    padding: 8px;
    &:focus {
      outline: none;
    }
    &:disabled {
      background-color: $light-grey-2;
    }
    &.number {
      text-align: center;
    }
  }

  &.tes-number-input-disabled input[readonly='readonly'] {
    height: 3em;
    width: 3em;
    font-size: inherit;
    text-align: center;
    border: 1px solid $row-border;
    background-color: $light-grey-2;
  }

  &.tes-number-input,
  &.form-number-input {
    .input-field {
      text-align: center;
    }
  }
  &.error {
    border: 1px solid $red;
    background-color: $modified-form;
    .input-field {
      background-color: $modified-form;
    }
  }
}

@media print {
  .input-field {
    border: none;
    background-color: rgba(255, 255, 255, 0);
    padding: 0;
  }
}
</style>
